import type React from 'react';

/* eslint-disable-next-line no-restricted-imports */
import RootTooltip, { type TooltipProps as RootTooltipProps } from '@mui/material/Tooltip';

import { nodeHasRenderableContent } from '../../util/elements';

export interface TooltipProps extends RootTooltipProps {
  readonly isDisabled?: boolean;
}

export const Tooltip: React.FC<TooltipProps> = ({
  children,
  isDisabled = false,
  title,
  ...props
}) => {
  if (isDisabled || !nodeHasRenderableContent(title)) {
    return children;
  }
  return (
    <RootTooltip {...props} title={title}>
      {children}
    </RootTooltip>
  );
};
